import { TableDataConfig } from '@pt/api/assets/index.type'
import { AssetStatus } from '@pt/enums/assets'

import OrderSelect from '@pt/components/order-select.vue'
import SearchInput from '@pt/components/search-input.vue'
import { TableData } from './type'

import _ from 'lodash'

import defaultImg from '@/assets/playturbo/default-image-label.png'
import defaultVideo from '@/assets/playturbo/default-video-label.png'
import defaultSound from '@/assets/playturbo/icon-sound-label.png'
import defaultPsd from '@/assets/playturbo/default-psd.png'
import defaultZip from '@/assets/playturbo/default-zip.png'
import defaultH5 from '@/assets/playturbo/default-h5.png'
import defaultFont from '@/assets/playturbo/default_font.png'
import { filterSchemaConfig } from '@pt/views/pt-entry/components/filter-bar/filter-model'
import i18n from '@/lang'
export const searchFormSchema = [
  {
    type: 'object',
    properties: {
      search_field: {
        component: 'select',
        class: 'search-field',
        noRefresh: true, // 禁止刷新路由
        field: {
          options: [
            {
              label: i18n.t('resourceManager.filter.assetName'),
              value: 'name',
            },
            {
              label: i18n.t('resourceManager.filter.assetId'),
              value: 'id',
            },
          ],
        },
      },
      keyword: {
        component: SearchInput,
        class: 'search-keyword',
        field: {
          placeholder: i18n.t('resourceManager.filter.search'),
        },
      },
      formats: filterSchemaConfig.formats,
      types: filterSchemaConfig.types,
      order: {
        component: OrderSelect,
        class: 'select-order',
        field: {
          options: [
            {
              label: i18n.t('resourceManager.filter.createTime'),
              value: 'created_time',
            },
            {
              label: i18n.t('resourceManager.filter.updateTime'),
              value: 'updated_time',
            },
            {
              label: i18n.t('resourceManager.filter.assetName'),
              value: 'name',
            },
            {
              label: i18n.t('resourceManager.filter.fileSize'),
              value: 'file_size',
            },
          ],
        },
      },
    },
  },
]

export const getDataSource = (source: number) => {
  switch (source) {
    case 1:
      return `${i18n.t('resourceManager.filter.upload')}`
    case 2:
      return `${i18n.t('resourceManager.filter.share')}`
    case 3:
      return `${i18n.t('resourceManager.filter.synchronization')}`
    case 4:
      return `${i18n.t('resourceManager.filter.playturbo')}`
    default:
      return '-'
  }
}

export const getStatusData = (status: AssetStatus) => {
  switch (status) {
    case AssetStatus.Pending:
    case AssetStatus.Transcoding:
      return `${i18n.t('playTurbo.assetLibrary.asset.transcode.transcoding')}`
    case AssetStatus.Active:
      return `${i18n.t('playTurbo.assetLibrary.asset.transcode.active')}`
    case AssetStatus.Error:
      return `${i18n.t('playTurbo.assetLibrary.asset.transcode.error')}`
    default:
      return '-'
  }
}

export const getStatusColor = (status: AssetStatus) => {
  switch (status) {
    case AssetStatus.Pending:
    case AssetStatus.Transcoding:
      return '#DEDFE0'
    case AssetStatus.Active:
      return '#52C41A'
    case AssetStatus.Error:
      return '#F5222D'
    default:
      return ''
  }
}

export const getCreativeType = (type: string) => {
  switch (type) {
    case 'image':
      return `${i18n.t('resourceManager.filter.image')}`
    case 'audio':
      return `${i18n.t('resourceManager.filter.audio')}`
    case 'video':
      return `${i18n.t('resourceManager.filter.video')}`
    case 'h5':
      return `${i18n.t('resourceManager.filter.h5')}`
    case 'font':
      return `${i18n.t('resourceManager.filter.font')}`
    case 'psd':
      return `${i18n.t('resourceManager.filter.psd')}`
    case 'dragonbone':
      return `${i18n.t('resourceManager.filter.dragonbone')}`
    case 'seqframe':
      return `${i18n.t('resourceManager.filter.seqframe')}`
    case 'zip':
      return `${i18n.t('resourceManager.filter.zip')}`
    case 'vrecpkg':
      return `${i18n.t('resourceManager.filter.screenRecordFile')}`
    default:
      return '-'
  }
}

export const handleInvertSelect = (
  listData: TableData[],
  selectList: TableData[],
  valueKey = 'id',
) => {
  const selectIds = _.map(selectList, valueKey)

  const invertList = listData.filter((item) => {
    return (
      selectIds.indexOf((item as any)[valueKey]) === -1 &&
      ((item.creative_type === 'video' &&
        item.status !== AssetStatus.Pending &&
        item.status !== AssetStatus.Transcoding) ||
        item.creative_type !== 'video')
    )
  })
  return invertList
}

export const coverImg = (type: string) => {
  switch (type) {
    case 'image':
      return defaultImg
    case 'audio':
      return defaultSound
    case 'video':
      return defaultVideo
    case 'vrecpkg':
      return defaultZip
    case 'psd':
      return defaultPsd
    case 'dragonbone':
    case 'seqframe':
    case 'zip':
      return defaultZip
    case 'h5':
      return defaultH5
    case 'font':
      return defaultFont
    default:
      return defaultImg
  }
}

export interface DialogConfig {
  visible: boolean
  mainTitle: string
  subTitle: string
  loading: boolean
}

export const initQuery = (query: any, stringList: string[] = []) => {
  const query_copy = _.cloneDeep(query)
  for (const key in query) {
    if (stringList.indexOf(key) !== -1) {
      query_copy[key] = query[key]
    } else if (
      typeof query[key] === 'string' &&
      query[key] &&
      _.isNaN(Number(query[key]))
    ) {
      query_copy[key] = query[key]
    } else if (
      typeof query[key] === 'string' &&
      query[key] &&
      !_.isNaN(query[key])
    ) {
      query_copy[key] = Number(query[key])
    } else if (query[key] instanceof Object && query[key].length) {
      if (!_.isNaN(Number(query[key][0]))) {
        query_copy[key] = _.map(query[key], (item) => {
          return (item = Number(item))
        })
      }
    }
  }
  return query_copy
}
